/*
 * @Description:
 * @Date: 2024-03-20 22:18:37
 */
import _ConfigDetailVue from './config-detail.vue';

export const ConfigDetailVue = _ConfigDetailVue;
